import { atom } from 'jotai';

import {
  AppointmentPatientFileArea,
  DraftAppointmentPatientFileArea,
  LineVisitorFileArea,
  OutpatientQuestionnaireEntryFileArea,
  TelemedicinePatientFileArea,
  WebVisitorFileArea,
} from './types';

export const webVisitorFileAreaState = atom<WebVisitorFileArea>({
  type: null,
  appointmentId: null,
});

export const lineVisitorFileAreaState = atom<LineVisitorFileArea>({
  type: null,
  appointmentId: null,
});

export const appointmentPatientFileAreaState = atom<AppointmentPatientFileArea>({
  type: null,
  appointmentId: null,
  patientId: null,
});

export const draftAppointmentPatientFileAreaState = atom<DraftAppointmentPatientFileArea>({
  type: null,
  draftAppointmentId: null,
  patientId: null,
});

export const telemedicinePatientFileAreaState = atom<TelemedicinePatientFileArea>({
  type: null,
  appointmentId: null,
  patientId: null,
});

export const outpatientQuestionnaireEntryFileAreaState = atom<OutpatientQuestionnaireEntryFileArea>(
  {
    type: null,
    outpatientQuestionnaireEntryId: null,
  },
);
